import { z } from 'zod'

/**
 * Why an organization came off an AI app connection: an Owner removed it,
 * its MCP setting was turned off, the person was removed from it, or it
 * closed. Stored as a string (`McpConnectionTenant.removedReason`), not a
 * Prisma enum.
 */
export const MCP_ORG_REMOVAL_REASONS = ['owner_removed', 'setting_off', 'member_removed', 'tenant_closed'] as const

export const mcpOrgRemovalReasonSchema = z.enum(MCP_ORG_REMOVAL_REASONS)

export type McpOrgRemovalReason = z.infer<typeof mcpOrgRemovalReasonSchema>
